import { CherryPayApi } from "../../api/models";

export const EventStatuses: CherryPayApi.EventStatus[] = [
  "Draft",
  "Published",
  "Cancelled",
  "Completed",
  "Deleted",
];

export const EventSortByOptions: CherryPayApi.EventSortByOption[] = [
  "NameAsc",
  "NameDesc",
  "EventDateNewestFirst",
  "EventDateOldestFirst",
  "LastModifiedNewestFirst",
  "LastModifiedOldestFirst",
];

export const EventSortByLabels: {
  [key in CherryPayApi.EventSortByOption]: string;
} = {
  NameAsc: "Name (A-Z)",
  NameDesc: "Name (Z-A)",
  EventDateNewestFirst: "Event Date (Newest First)",
  EventDateOldestFirst: "Event Date (Oldest First)",
  LastModifiedNewestFirst: "Last Modified (Newest First)",
  LastModifiedOldestFirst: "Last Modified (Oldest First)",
};
